import { useEffect, useState } from "react";
import { Modal, Box, Typography, Slide, Button, Stack, Container, Divider, TextField, CircularProgress } from "@mui/material"
import { Close as CloseIcon } from '@mui/icons-material';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { FeatureState, getAllFeatureTask } from "../../global/GlobalFcn";
import { ComputePercentage, GetPercentageFormat, StartUpperCase } from "../../../../../core/global/Format";
import { GetToolUsageDetails } from "../../../../../core/global/API";
import { FetchingGraphDates } from "../../global/GlobalFcn";
import { CheckCircleIcon } from "../../global/Icons";
import { UserSummary } from "../userSummary/UserSummary";
import moment from "moment/moment";

export const DetailsModal = ({open, setOpen, graphDatasets, __SESSION})=>{
    
    const [usageDetailed, setUsageDetailed] = useState({
        loader:false,
        average:0,
        data:[],
        date:{value:new Date(), error:false, msg:''}
    })

    // SAMPLE DATA
    // const res_data = [
    //     {feature_id:1, feature_name:"dashboard", path:"1", action:2, count:1},
    //     {feature_id:2, feature_name:"bcloud", path:"2", action:2, count:1},
    //     {feature_id:2, feature_name:"registration", path:"2->2", action:1, count:1},
    //     {feature_id:2, feature_name:"registration", path:"2->2", action:2, count:1},
    //     {feature_id:2, feature_name:"registration", path:"2->2", action:3, count:1},
    //     {feature_id:1, feature_name:"category", path:"3->1", action:2, count:1},
    //     {feature_id:1, feature_name:"category", path:"3->1", action:3, count:1},
    //     {feature_id:2, feature_name:"concern", path:"3->3", action:1, count:1},
    //     {feature_id:4, feature_name:"general-maintenance", path:"4", action:2, count:1},
    // ]
    // const res_target = [
    //     {feature_name:"dashboard", path:"1", action:[2]},
    //     {feature_name:"bcloud", path:"2", action:[2]},
    //     {feature_name:"recently", path:"2->1", action:[2]},
    //     {feature_name:"registration", path:"2->2", action:[1,2,3,4]},
    //     {feature_name:"contracts", path:"2->3", action:[1,2,3,4]},
    //     {feature_name:"my-documents", path:"2->4", action:[1,2,3,4]},
    //     {feature_name:"shared-documents", path:"2->5", action:[1,2,3,4]},
    //     {feature_name:"favorites", path:"2->6", action:[2,3,4]},
    //     {feature_name:"trash", path:"2->7", action:[2,3,4]},
    //     {feature_name:"policies", path:"3", action:[2]},
    //     {feature_name:"category", path:"3->1", action:[1,2,3]},
    //     {feature_name:"team", path:"3->2", action:[1,2,3]},
    //     {feature_name:"concern", path:"3->3", action:[1,2,3]},
    //     {feature_name:"general-maintenance", path:"4", action:[2]},
    //     {feature_name:"company-setup", path:"4->1", action:[1,2,3]},
    //     {feature_name:"number-sequence", path:"4->2", action:[1,2,3]},
    //     {feature_name:"master-list", path:"4->3", action:[2]},
    //     {feature_name:"department", path:"4->3->1", action:[1,2,3]},
    //     {feature_name:"position", path:"4->3->2", action:[1,2,3]},
    //     {feature_name:"user", path:"4->3->3", action:[1,2,3]},
    //     {feature_name:"client", path:"4->3->4", action:[1,2,3]},
    //     {feature_name:"user-role", path:"4->4", action:[2,3]},
    //     {feature_name:"hero", path:"5", action:[2]},
    //     {feature_name:"tool-categories", path:"6", action:[2]},
    //     {feature_name:"profile", path:"7", action:[1,2,3]}
    // ]

    const inputHandler = (e) => {
        const { name, value } = e.target
        setUsageDetailed((prev) => ({...prev, 
            [name]:{value:value, error:value === '', msg:value === '' && 'Invalid Date'}
        }))
    }

    const handleGenerate = async() => {
        if (new Date() >= usageDetailed.date.value && usageDetailed.date.value ) {
            setUsageDetailed((prev) => ({...prev, 
                loader:true
            }))
            await getUsageDetails(moment(usageDetailed.date.value).format("MM-DD-YYYY"))
        }else{
            setUsageDetailed((prev) => ({...prev, 
                date:{...prev.date.value, error:true, msg:'Invalid Date!'}
            }))
        }
    }

    const getUsageDetails = async(date) => {
        setUsageDetailed((prev) => ({...prev, 
            loader:true
        }))

        if (graphDatasets.data.dates.length > 0) {
            let res_dates = await FetchingGraphDates('daily', 4, 'desc', date, '1st')
            let rd = res_dates.dates
            let role_type = graphDatasets.data.assigned_id === 0 ? __SESSION.data.uaccess[0]?.role_name : graphDatasets.data.role_name
            let res_target = await FeatureState('usage-detailed', role_type) || console.log('Feature Name is Not Found!')
            
            let values = []
            for (let i = 0; i < rd.length; i++) {
                let qsp = {
                    company_id:__SESSION.data.uaccess[0]?.company_id,
                    tool_id:parseInt(process.env.REACT_APP_TID_BIZ),
                    user_id:graphDatasets.data.assigned_id === 0 ? parseInt(atob(__SESSION.data.ainfo.aid).split('_', 2)[1]) : graphDatasets.data.assigned_id,
                    date_from:rd[i][0],
                    date_to:rd[i][1],
                }
                let res_data = await GetToolUsageDetails(qsp)
                let res = getAllFeatureTask(res_target, res_data)
                
                const finalArray = res.map(r => {
                    const totalCount = r.sub.reduce((sum, item) => sum + item.count, 0);
                    const totalPossible = r.sub.length;
        
                    const usage = totalPossible > 0 ? ComputePercentage(totalCount, totalPossible) : 0;
        
                    return {...r, usage:usage};
                });
                
                const averageUsage = finalArray?.reduce((sum, item) => sum + parseFloat(item.usage), 0) / finalArray?.length
                
                values = [...values, {date:rd[i][0], average:GetPercentageFormat(averageUsage), data:finalArray}]
            }
            
            const totalAverageUsage = values?.reduce((sum, item) => sum + parseFloat(item.average), 0) / values?.length
            
            setUsageDetailed((prev) => ({...prev, 
                data:values, 
                average:GetPercentageFormat(Math.ceil(totalAverageUsage)) || 0,
                loader:false, 
                start_date:res_dates.start_date,
                last_date:res_dates.last_date
            }))
        }
    }

    useEffect(() => {
        getUsageDetails(moment(new Date()).format("MM-DD-YYYY"))
        // eslint-disable-next-line
    }, [graphDatasets.data.dates])
    
    return(
        <Modal open={open} onClose={()=>{setOpen(false)}}>
            <Slide in={open} direction="up" className="noutlined">
                <Box component={Container} height="100%">
                    <Box sx={{height: "10%"}}></Box>
                    <Box boxShadow="0px 8px 16px 0px #00000014;" sx={{bgcolor: "#fff", width: "100%", height: "90%", p: 3, borderTopLeftRadius: 8, borderTopRightRadius: 8}}>
                        <Stack height="100%" width="100%" gap="10px">
                            <Stack minHeight="32px" width="100%" direction="row" justifyContent="space-between" alignItems="center" >
                                <Stack gap={1} mb={1}>
                                    <Typography fontWeight={600} fontSize={16} lineHeight="120%" letterSpacing="-0.75%" color="#292C2F">Usage Detailed Report</Typography>
                                    <Typography fontWeight={400} fontSize={16} lineHeight="120%" letterSpacing="-0.75%" color="#5B6167">
                                        {moment(usageDetailed.start_date).format('MMM DD')} - {moment(usageDetailed.last_date).format('DD, YYYY')}
                                    </Typography>
                                </Stack>
                                <Box className="c-pointer">
                                    <CloseIcon onClick={()=>{setOpen(false)}} sx={{fontSize: 20}}/>
                                </Box>
                            </Stack>
                            <Stack minHeight="72px" direction="row" justifyContent="space-between" alignItems="center">
                                <UserSummary graphDatasets={graphDatasets} __SESSION={__SESSION} percentage={usageDetailed.average} loader={usageDetailed.loader}/>
                                <Stack direction="row" gap={2} alignItems="center">
                                    <Box width="170px">
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker 
                                                disableFuture
                                                views={['day']} 
                                                label="" 
                                                value={usageDetailed.date.value} 
                                                onChange={(v)=>inputHandler({target: {name: 'date', value: v}})}
                                                renderInput={(params) => 
                                                    <TextField size="small" {...params} 
                                                        error={usageDetailed.date.error} 
                                                        helperText={usageDetailed.date.msg}
                                                    />
                                                }
                                            />
                                        </LocalizationProvider>
                                    </Box>
                                    <Button 
                                        onClick={()=>handleGenerate()}
                                        disabled={usageDetailed.loader}
                                        sx={{
                                            width:'100px',
                                            height:'40px',
                                            bgcolor: "#003022", 
                                            "&:hover": {backgroundColor: "#003022", boxShadow: "none",} 
                                        }}
                                    >
                                        <Typography fontWeight={400} fontSize={12} lineHeight="142%" letterSpacing="0%" color="#FFFFFF">Generate</Typography>
                                    </Button>
                                    {/* <Button 
                                        disabled
                                        sx={{
                                            width:'62px',
                                            height:'40px',
                                            bgcolor: "#003022", 
                                            "&:hover": {backgroundColor: "#003022", boxShadow: "none",}, 
                                            "&:disabled": {opacity: 0.2, boxShadow: "none",} 
                                        }}
                                    >
                                        <Typography fontWeight={400} fontSize={12} lineHeight="142%" letterSpacing="0%" color="#FFFFFF">Export</Typography>
                                    </Button> */}
                                </Stack>
                            </Stack>
                            {usageDetailed.loader ? 
                                <Box height="100%" width="100%" display="flex" alignItems="center" justifyContent="center">
                                    <Box height="100%" width="270px" borderRadius="12px" display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={3}>
                                        <Stack sx={{ color: 'grey.300' }} spacing={2} direction="row">
                                            <CircularProgress color="inherit"  />
                                        </Stack>
                                        <Box color="#000">Please wait...</Box>
                                    </Box>
                                </Box>
                            :
                                <Box height="100%" className="overflowY">
                                    {usageDetailed.data.map((m,i) => (
                                        <Stack key={i} gap={2}>
                                            <Stack minHeight="30px">
                                                <Typography fontWeight={700} fontSize={20} lineHeight="120%" letterSpacing="-0.75%" color="#292C2F">{moment(m.date).format('MMM-DD, YYYY')}</Typography>
                                            </Stack>
                                            <Stack minHeight="18px" direction="row" justifyContent="space-between" alignItems="center" gap="21px">
                                                <Typography minWidth="256px" fontWeight={400} fontSize={12} lineHeight="147%" letterSpacing="0%" color="#5B6167">Feature</Typography>
                                                <Typography minWidth="256px" fontWeight={400} fontSize={12} lineHeight="147%" letterSpacing="0%" color="#5B6167">Percentage</Typography>
                                                <Typography width="100%" fontWeight={400} fontSize={12} lineHeight="147%" letterSpacing="0%" color="#5B6167">Actions</Typography>
                                            </Stack>
                                            {m.data.map((s,ii) => (
                                                <Stack key={ii}>
                                                    <Stack minHeight="18px" direction="row" justifyContent="space-between" gap="21px">
                                                        <Typography minWidth="256px" fontWeight={400} fontSize={14} lineHeight="147%" letterSpacing="0%" color="#000000">{StartUpperCase(s.feature_name)}</Typography>
                                                        <Stack minWidth="256px" >
                                                            <Stack width="60px" height="30px" bgcolor="#E7E8EA" borderRadius="100px" direction="row" justifyContent="center" alignItems="center">
                                                                <Typography fontWeight={400} fontSize={14} lineHeight="147%" letterSpacing="0%" color="#000000">{s.usage}%</Typography>
                                                            </Stack>
                                                        </Stack>
                                                        <Stack width="100%" gap={1}>
                                                            {s.sub.map((ss,iii) => (
                                                                <Stack key={iii} direction="row" gap="14px">
                                                                    <CheckCircleIcon fill={ss.count === 1 ? '#5DB55D' : '#B5BBC1'}/>
                                                                    <Typography width="100%" fontWeight={400} fontSize={12} lineHeight="147%" letterSpacing="0%" color="#000000">{ss.to_do}</Typography>
                                                                </Stack>
                                                            ))}
                                                        </Stack>
                                                    </Stack>
                                                    <Divider sx={{my:'11px'}}/>
                                                </Stack>
                                            ))}
                                        </Stack>
                                    ))}
                                </Box>
                            }
                        </Stack>
                    </Box>
                </Box>
            </Slide> 
        </Modal>
    )
}